import { render, staticRenderFns } from "./OEmbed.vue?vue&type=template&id=4ca18886&"
import script from "./OEmbed.vue?vue&type=script&lang=js&"
export * from "./OEmbed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports